import { ContentAreas } from '../../types/contentAreas';
import { SingleViewLayout } from './SingleViewLayout';
import { StackedViewLayout } from './StackedViewLayout';
import { StackedViewWithDividersLayout } from './StackedViewWithDividersLayout';

type LayoutComponent = ({ contentAreas }: { contentAreas: ContentAreas }) => JSX.Element;
type Layouts = Record<string, LayoutComponent>;

export const LAYOUTS: Layouts = {
  single_view: SingleViewLayout,
  stacked_view: StackedViewLayout,
  stacked_view_with_dividers: StackedViewWithDividersLayout,
};
